import { getTimestampFromDuration } from "../utils/timestampUtils";
import { htmlToText} from 'html-to-text';
import jsPDF from 'jspdf';
import { encode as base64_encode } from 'base-64';
import { NodeHtmlMarkdown } from 'node-html-markdown';
import { indexForNextOfType } from "../MainVideoPage/bookmarks";

const bookmarks2json = (podcast) => {
    return JSON.stringify({
        podcastMetadata: podcast.podcastMetadata, 
        bookmarks: podcast.bookmarks.slice(0,-1),
        section: podcast.section ? podcast.section : 0
    });
}

const exportUrl = (podcast) => {
    const {title, encodedRssFeed, bookmarks, encodedMp3, section, podcastMetadata} = podcast;
    let b64code = base64_encode(
        JSON.stringify({
            podcastMetadata: podcastMetadata,
            bookmarks: bookmarks,
            section: section
    }));
    return `${window.location.origin}/podcasts/${encodedRssFeed}/mp3/${encodedMp3}/bookmarks/${b64code}`;
}

function bookmarks2md(podcast) {
    const {bookmarks, podcastMetadata} = podcast;
    let md_sting = "# " + podcastMetadata.title + "\n";
    md_sting += "rssFeed: " + podcastMetadata.rssFeed + "\n";
    md_sting += "description: " + podcastMetadata.description + "\n";

    for (const [index, bm] of bookmarks.slice(0, -1).entries()) {
        //let link = exportUrl({encodedRssFeed, encodedMp3, bookmarks, index, podcastMetadata});
        if (bm.type === "section") {
            const nextIndex = indexForNextOfType(
                "section",
                bookmarks,
                index
            )
            if ("text" in bm) {
                if (nextIndex < bookmarks.length) {
                    md_sting += ("## " + bm["text"] + " " + getTimestampFromDuration(Math.round(bm.time)) + " - " 
                    + getTimestampFromDuration(Math.round(bookmarks[nextIndex].time)) + "\n");
                } else {
                    md_sting += "";
                }
            } else {
                if (nextIndex < bookmarks.length) {
                    md_sting += ("#" + getTimestampFromDuration(Math.round(bm.time)) + " - " 
                        + getTimestampFromDuration(Math.round(bookmarks[nextIndex].time)) +"\n");
                } else {
                    md_sting += "";
                }
            }
        }
        if (bm.type === "timestamp"){
            md_sting += ("> [" + getTimestampFromDuration(Math.round(bm.time)) + "](" + link + ') "' 
                + bm["text"] + '"\n');
        }
        md_sting += "\n";
        md_sting +=  NodeHtmlMarkdown.translate(bm.notes);
        md_sting += "\n";
        md_sting += "\n";
    }
    return md_sting;
}

function bookmarks2text(podcast) {
    const title = podcast.podcastMetadata.title + "\n";
    const bookmarksTextContent = podcast.bookmarks
                                    .slice(0, -1)
                                    .map((bm, index) =>
                                    `${index + 1}. ${getTimestampFromDuration(bm.time)}\n${bm.notes ? htmlToText(bm.notes) + '\n' : ''}`)
                                    .join('\n');
    return title + bookmarksTextContent;
}


function download_file(file_blob, file_name){
    const url = URL.createObjectURL(file_blob); // Generate a URL for the Blob
    const link = document.createElement('a'); // Create a new anchor element dynamically
    link.href = url; // Set the href 
    link.download = file_name; //download attributes for the anchor element
    document.body.appendChild(link); // Append the anchor to the document
    link.click(); // Trigger a click on the anchor to start the download
    document.body.removeChild(link); // Remove the anchor from the document
}

function exportToMarkdown(podcast) {
    const markdownContent = bookmarks2md(podcast);
    const encodedMp3 = podcast.encodedMp3;
    const fileName = encodedMp3.substring(0, 15);
    const blob = new Blob([markdownContent], { type: 'text/markdown;charset=utf-8' });
    if (podcast.clipboard) {
        navigator.clipboard.writeText(markdownContent);
    } else{
        download_file(blob, `bookmarks_${fileName}.md`)
    }
};

// Export to Text
function exportToText(podcast) {
    const textContent = bookmarks2text(podcast); 
    const encodedMp3 = podcast.encodedMp3;
    const fileName = encodedMp3.substring(0, 15);
    const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8' });
    if (podcast.clipboard) {
        navigator.clipboard.writeText(textContent);
    }else{
        download_file(blob, `bookmarks_${fileName}.txt`)
    }
};


function exportBookmarks(podcast) {
    let jsonString = bookmarks2json(podcast);
    const encodedMp3 = podcast.encodedMp3;
    const fileName = encodedMp3.substring(0, 15);
    const blob = new Blob([jsonString], { type: 'application/json' });
    download_file(blob, `podcast_${fileName}.json`);
};


function exportToPDF(podcast) {
    const { bookmarks, podcastMetadata} = podcast;
    const encodedMp3 = podcast.encodedMp3;
    const fileName = encodedMp3.substring(0, 15);
    const pdfContent = `${podcastMetadata.title}\n\n
    ${bookmarks
    .slice(0, -1)
    .map(
        (bm, index) =>
        `${index + 1}. ${getTimestampFromDuration(bm.time)}\n${bm.notes ? htmlToText(bm.notes) + '\n' : ''}`
    )
    .join('\n')}`;

    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(pdfContent, 10, 10);
    doc.save(`bookmarks_${fileName}.pdf`);
};

export function exportInClipThoughtsFormat(podcast) {
    const { encodedMp3 } = podcast; 
    const fileName = encodedMp3.substring(0, 15);
    let jsonString = bookmarks2json(podcast);
    const blob = new Blob([jsonString], { type: 'application/json' });
    download_file(blob, `podcast_${fileName}.json`);
};

export { exportUrl, bookmarks2md, exportToMarkdown, exportToText, exportBookmarks, exportToPDF, bookmarks2json };